import { Controller } from "@hotwired/stimulus";
import { toJpeg } from "html-to-image";

export default class extends Controller {
  download() {
    const area = document.querySelector(".deck-visual-graphic-area");
    if (!area) return;

    const button = this.element.querySelector("button");
    const originalText = button.textContent;
    button.textContent =
      "Generating... This may take a few minutes. Don't close your browser.";
    button.disabled = true;

    toJpeg(area, {
      pixelRatio: 1,
      quality: 0.92,
      imagePlaceholder: "",
    })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "deck-visual.jpg";
        link.href = dataUrl;
        link.click();
        button.textContent = originalText;
        button.disabled = false;
      })
      .catch((err) => {
        console.error("Deck image download failed:", err);
        button.textContent = "Download failed — try again";
        button.disabled = false;
        setTimeout(() => {
          button.textContent = originalText;
        }, 3000);
      });
  }
}
